import repos from '../../libs/Repository'
import * as types from './types'
import api from '../../libs/Api'
import co from 'co'
import constants from '../../constants'

function genOfficeSlotName (officeId) {
  return `officeId:${officeId}`
}

export default {
  namespaced: true,
  state: {
    targetOfficeId: null,
    targetUserId: null,
    targetDate: null,
    staffs: null,
    staffsList: [],
    usersList: [],
    selectedOfficeIdNumber: null,
    planToEdit: null
  },
  mutations: {
    [types.SET_TARGET_OFFICE_ID] (state, value) {
      state.targetOfficeId = value
    },
    [types.SET_TARGET_USER_ID] (state, value) {
      state.targetUserId = value
    },
    [types.SET_TARGET_DATE] (state, value) {
      state.targetDate = value
    },
    [types.SET_STAFFS_LIST] (state, { key, value }) {
      if (!state.staffsList) state.staffsList = {}
      state.staffsList[key] = value
    },
    [types.SET_USERS_LIST] (state, { key, value }) {
      if (!state.usersList) state.usersList = {}
      state.usersList[key] = value
    },
    [types.SET_PLAN_TO_EDIT] (state, value) {
      state.planToEdit = value
    }
  },
  actions: {
    init ({ commit }) {
      commit(types.SET_STAFFS_LIST, { key: 'init', value: [] })
      commit(types.SET_USERS_LIST, { key: 'init', value: [] })
    },
    setTargetOfficeId ({ commit, state }, officeId) {
      if (!officeId) {
        commit(types.SET_TARGET_OFFICE_ID, null)
        commit(types.SET_TARGET_USER_ID, null)
        return Promise.resolve([])
      }

      return co(function * () {
        const numericOfficeId = Number(officeId)
        const slotName = genOfficeSlotName(numericOfficeId)

        commit(types.SET_TARGET_OFFICE_ID, numericOfficeId)
        state.selectedOfficeIdNumber = numericOfficeId

        // staff
        let staffs = state.staffsList[slotName]
        if (!staffs) {
          staffs = yield api.getStaffs(constants.QUERY_MODE_TRIM_GET, 1, numericOfficeId)
          commit(types.SET_STAFFS_LIST, { key: slotName, value: staffs })
        }

        // user
        let users = state.usersList[slotName]
        if (!users) {
          users = yield api.getUser(constants.QUERY_MODE_TRIM_GET, null, numericOfficeId)
          commit(types.SET_USERS_LIST, { key: slotName, value: users })
        }

        return Promise.resolve([staffs, users])
      }).catch(error => {
        console.error('Error in setTargetOfficeId:', error)
        commit(types.SET_TARGET_OFFICE_ID, null)
        commit(types.SET_TARGET_USER_ID, null)
        return Promise.reject(error)
      })
    },
    setTargetUserId ({ commit }, value) {
      commit(types.SET_TARGET_USER_ID, value)
    },
    setTargetDate ({ commit }, value) {
      commit(types.SET_TARGET_DATE, value)
    },
    setPlanToEdit ({ commit }, value) {
      commit(types.SET_PLAN_TO_EDIT, value)
      return Promise.resolve(value)
    },
    savePlan ({ commit }, args) {
      if (args.id) {
        return api.updatePlan(args)
      } else {
        return api.createPlan(args)
      }
    },
    destroyPlan ({ commit }, id) {
      return api.deletePlan(id)
    },
    getPlans ({ commit }, args) {
      return api.getPlans(args)
    }
  },
  getters: {
    isLoggedIn () {
      return !!(repos.getToken())
    },
    staffs: (state) => {
      if (!state.targetOfficeId) return []
      const slotName = genOfficeSlotName(state.targetOfficeId)
      return state.staffsList[slotName] || []
    },
    users: (state) => {
      if (!state.targetOfficeId) return []
      const slotName = genOfficeSlotName(state.targetOfficeId)
      return state.usersList[slotName] || []
    }
  }
}
